import { AlertCircle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

interface ErrorDisplayProps {
  error?: Error | null
  title?: string
  message?: string
  onRetry?: () => void
}

export function ErrorDisplay({ 
  error, 
  title = 'Error',
  message,
  onRetry 
}: ErrorDisplayProps) {
  const displayMessage = message || error?.message || 'Something went wrong'
  
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="flex items-center justify-between gap-4">
        <span>{displayMessage}</span>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Try Again
          </Button>
        )}
      </AlertDescription>
    </Alert>
  )
}
